import _ from "lodash";
import React, { useState } from "react";
import { connect } from "react-redux";
import { useI18n } from "Hooks";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import { Button, Dropdown, DropdownMenu, IconButton } from "@toddle-edu/ds-web";
import {
  TickCircleFilled,
  DotsHorizontalOutlined,
  CloseCircleOutlined,
} from "@toddle-edu/ds-icons";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  CORE_TOK_AND_OTHER_TYPES,
  STAFF,
} from "Constants/stringConstants";
import {
  getDropdownOptions,
  getIsCategorySetsExistsForAllSubjects,
  getAbsolutePercentageValueMemoize,
} from "ScoreCategories/modules/Utils";
import {
  copyPointAssessment,
  getUsedCoursesAndCategorySetNames,
  showToastAfterDuplicatingCategorySetsToGrade,
} from "ScoreCategories/modules/ScoreCategoriesModule";
import {
  getTermWiseCategorySetsCount,
  getEntitiesForCopySet,
  getAssociatedEntitiesForBulkImport,
} from "routes/routes/Administrator/routes/DPAcademicSetup/routes/AssessmentCategories/modules/AssessmentCategoriesModule";
import {
  checkIsAssessmentSetupV2Enabled,
  getIsAdminScoreV2,
} from "routes/routes/Administrator/routes/DPAcademicSetup/routes/AssessmentSetup/modules/utils";
import DuplicateTemplateModal from "../DuplicateTemplateModal";
import CategoryGradeBoundary from "ScoreCategories/components/CategoryGradeBoundary";
import CategoryGradeScale from "ScoreCategories/components/CategoryGradeScale";
import classNames from "classnames";
import classes from "./CategoryTemplate.scss";
import moment from "moment";
import BulkDuplicateTemplateModal from "../BulkDuplicateTemplateModal";
import ACLStore from "lib/aclStore";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import {
  getCategoryGradeBoundaryToggleLabel,
  getCanDefineGradeBoundary,
  getShowCategoryGradeBoundaryToggle,
  FINAL_GRADE_CALCULATION_SETTING,
} from "GradingSetup/modules/Utils";
import { getSettingValue } from "modules/PermissionModule";
import { getFormattedUserName } from "Utils/GetFormattedUserName";

const CategoryTemplate = props => {
  const {
    goToRelativeRoute,
    templateNode,
    setIsEditMode,
    onClickEditTemplate,
    curriculumType,
    isCourseApplicableToCategorySet,
    isAbsoluteWeightageType,
    subjectLevelGenericTags,
    setTemplateId,
    setShowDialogueBox,
    curriculumProgramId,
    termId,
    grades,
    rootNodes,
    subjectGroups,
    copyPointAssessment,
    subjectType,
    pointSetVariables,
    scoreBasedAssessmentVariables,
    subjectId,
    subjectName,
    organizationPointSet,
    isClassSettingsContext = false,
    setClassSettingMode,
    assessmentCategoryId,
    isTeacherAllowedToAddEditCategories,
    isGradingPeriodUnlocked = true,
    isNewTemplateDuplicationFlowEnabled,
    showToastAfterDuplicatingCategorySetsToGrade,
    isAssessmentSetupV2Enabled,
    terms,
    selectedTerms,
    setSelectedTerms,
    usedTerms,
    primaryGradeId,
    defaultGradeScaleSet,
    isWeightageEnabledForCategory,
    isNewAssessmentSettingsEnabled,
    canDefineGradeBoundary,
    finalGradeCalculationMethod,
    showCategoryGradeBoundaryToggle,
    currentCategoryGradeBoundaryValues,
    overallCategoryGradeBoundaryValues,
    updateCurrentCategoryGradeBoundaryValues,
    updateOverallCategoryGradeBoundaryValues,
    showUpdatedDesign = false,
  } = props;
  const { t } = useI18n(["common", "toastMsgs"]);
  const [modalState, setModalState] = useState("CLOSE");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedGrades, setSelectedGrades] = useState([]);
  const [modalParams, setModalParams] = useState({});
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);

  const isCurriculumDP = _.isEqual(curriculumType, CURRICULUM_TYPE_DP);
  const isCurriculumMYP = _.isEqual(curriculumType, CURRICULUM_TYPE_MYP);
  const isCurriculumUBD = _.isEqual(curriculumType, CURRICULUM_TYPE_UBD);
  const isScoreV2 = getIsAdminScoreV2({ curriculumType });

  const conditionalPercentage =
    isNewAssessmentSettingsEnabled ||
    isAbsoluteWeightageType ||
    isAssessmentSetupV2Enabled
      ? ""
      : "%";

  const entityType = isCourseApplicableToCategorySet ? "Course" : "Grade";

  const user = templateNode?.updatedBy || templateNode?.createdBy;
  const name = getFormattedUserName({
    user,
    type: STAFF,
  });

  const updatedTimeStamp = moment(_.get(templateNode, "updatedAt", ""));

  const updatedDate = updatedTimeStamp.format("MMMM DD,YYYY");
  const updatedTime = updatedTimeStamp.format("h:mm a");

  const templateId = _.get(templateNode, "id", "");
  const templateName = _.get(templateNode, "label", "");
  const isShowGradeBoundaries = _.get(
    templateNode,
    "isShowGradeBoundaries",
    false
  );

  const associatedChildPlannerElementNodes = _.orderBy(
    _.get(templateNode, "categories", []),
    "displaySequence",
    "asc"
  );
  const courses = _.filter(
    _.get(templateNode, "associatedEntities", []),
    associatedEntitiy =>
      _.get(associatedEntitiy, "__typename", "") === entityType
  );
  const coursesName = _.map(courses, course =>
    isCourseApplicableToCategorySet ? course.title : course.name
  );

  const openDuplicateToAllSubjectsModal = () => {
    setModalState("DUPLICATE_TO_ALL_SUBJECTS");
  };

  const openDuplicateToOtherGradesModal = () => {
    setModalState("DUPLICATE_TO_OTHER_GRADES");
  };

  const openDuplicateToOtherTermsModal = () => {
    setModalState("DUPLICATE_TO_OTHER_TERMS");
  };

  const closeModal = () => {
    setModalState("CLOSED");
    setSelectedTerms?.([]);
  };

  const showModal = _.includes(
    [
      "DUPLICATE_TO_ALL_SUBJECTS",
      "DUPLICATE_TO_OTHER_GRADES",
      "DUPLICATE_TO_OTHER_TERMS",
    ],
    modalState
  );

  const openDuplicateModal = () => {
    setShowDuplicateModal(true);
  };

  const closeDuplicateModal = () => {
    setShowDuplicateModal(false);
  };

  const {
    subjectsWithCategorySet,
    subjectsWithNoCategorySet,
  } = getTermWiseCategorySetsCount({ rootNodes, termId });

  const { usedCourses } = getUsedCoursesAndCategorySetNames({
    organizationPointSet,
    isCourseApplicableToCategorySet,
  });

  const gradesWithNoCategorySet = _.difference(
    _.map(grades, "id"),
    usedCourses
  );

  const termsWithNoCategorySet = _.difference(_.map(terms, "id"), usedTerms);

  const doesAllGradesHaveCategorySet = _.isEmpty(gradesWithNoCategorySet);

  const doesAllTermsHaveCategorySet = _.isEmpty(termsWithNoCategorySet);
  const onClickDuplicate = async () => {
    const params = {
      subjectsWithCategorySet,
      subjectsWithNoCategorySet,
      grades,
      entityType,
      termId,
    };

    if (
      modalState === "DUPLICATE_TO_OTHER_GRADES" ||
      modalState === "DUPLICATE_TO_OTHER_TERMS"
    ) {
      params["subjectId"] = subjectId;
      params["gradeIds"] = selectedGrades;
      params["termIds"] = selectedTerms;
      params["primaryGradeId"] = primaryGradeId;
      params["modalState"] = modalState;
    }

    setIsLoading(true);
    await copyPointAssessment({
      id: templateId,
      label: templateName,
      entitesForCopySet: getEntitiesForCopySet(params),
      curriculumProgramId,
      pointSetVariables,
      type: "ASSESSMENT_CATEGORY",
      scoreBasedAssessmentVariables,
    });
    setIsLoading(false);
    closeModal();
    showToastAfterDuplicatingCategorySetsToGrade({
      selectedGrades,
      t,
      grades,
      modalState,
      selectedTerms,
    });
  };

  const categoryHeaderTextClass = classNames({
    [classes.categoryHeaderText]: true,
    [classes.categoryHeaderTextForScoreCalculationType]: isNewAssessmentSettingsEnabled,
  });

  const categoryNameContainerClass = classNames({
    [classes.categoryNameContainer]: true,
    [classes.categoryNameContainerForScoreCalculationType]: isNewAssessmentSettingsEnabled,
  });

  const percentageWeightClass = classNames({
    [classes.percentageWeight]: true,
    [classes.percentageWeightForScoreCalculationType]: isNewAssessmentSettingsEnabled,
  });

  const categoryWeightTextClass = classNames({
    [classes.categoryWeightText]: true,
    [classes.percentageWeightForScoreCalculationType]: isNewAssessmentSettingsEnabled,
  });

  const gradeBoundaryTextClass = classNames({
    [classes.categoryWeightText]: true,
    [classes.categoryWeightForScoreCalculationType]: isNewAssessmentSettingsEnabled,
  });

  const notAddedYetClass = classNames(
    classes.categoryWeightText,
    classes.textSubtle
  );

  const renderCategory = ({
    associatedChildPlannerElementNode,
    setModalParams,
  }) => {
    const label = _.get(associatedChildPlannerElementNode, "label", "");
    const categoryId = _.get(associatedChildPlannerElementNode, "id");
    const fieldColor = _.get(
      associatedChildPlannerElementNode,
      "colorCode",
      ""
    );
    const fieldPercentageWeight = _.get(
      associatedChildPlannerElementNode,
      "percentageWeight",
      ""
    );

    const fieldSLPercentageWeight = _.get(
      associatedChildPlannerElementNode,
      "slWeight",
      ""
    );

    const fieldHLPercentageWeight = _.get(
      associatedChildPlannerElementNode,
      "hlWeight",
      ""
    );

    const gradeBoundaryId = _.get(
      associatedChildPlannerElementNode,
      "gradeBoundary.id",
      ""
    );

    const gradeScaleType = _.get(
      associatedChildPlannerElementNode,
      "gradeScaleType"
    );

    const addedTextClass = classNames(classes.addedText, "text-body-1");

    let hasSLWeight = false;
    let hasHLWeight = false;
    _.forEach(subjectLevelGenericTags, tag => {
      const tagLabel = _.get(tag, "label");
      if (
        _.isEqual(tagLabel, "SL") &&
        (!isWeightageEnabledForCategory ||
          _.parseInt(fieldSLPercentageWeight) > 0)
      ) {
        hasSLWeight = true;
      } else if (
        !isWeightageEnabledForCategory ||
        _.parseInt(fieldHLPercentageWeight) > 0
      ) {
        hasHLWeight = true;
      }
    });

    const onClickAddedGradeBoundary = () => {
      setModalParams({
        label,
        categoryId,
        gradeBoundaryId,
        hasSLWeight,
        hasHLWeight,
        gradeScaleType,
      });
    };

    return (
      <div className={categoryTemplateDataCellSyle}>
        <div className={categoryNameContainerClass}>
          <div className={classes.categoryName}>{label}</div>
          <div
            className={classes.bgColor}
            style={{ backgroundColor: fieldColor }}
          />
        </div>
        {isWeightageEnabledForCategory &&
          (!isCurriculumDP ||
          (isCurriculumDP && _.isEmpty(subjectLevelGenericTags)) ? (
            <>
              <div className={percentageWeightClass}>
                {_.isNumber(fieldPercentageWeight)
                  ? _.concat(fieldPercentageWeight, conditionalPercentage)
                  : "-"}
              </div>
              {isNewAssessmentSettingsEnabled && (
                <div className={percentageWeightClass}>
                  {getAbsolutePercentageValueMemoize({
                    key: "percentageWeight",
                    value: fieldPercentageWeight,
                    fieldValues: associatedChildPlannerElementNodes,
                  })}
                </div>
              )}
            </>
          ) : (
            <>
              {_.map(subjectLevelGenericTags, tag => {
                const tagLabel = _.get(tag, "label", "");
                const isSLTag = _.isEqual(tagLabel, "SL");
                const percentageWeight = isSLTag
                  ? fieldSLPercentageWeight
                  : fieldHLPercentageWeight;

                return (
                  <>
                    <div className={percentageWeightClass}>
                      {_.isNumber(percentageWeight)
                        ? _.concat(percentageWeight, conditionalPercentage)
                        : "-"}
                    </div>
                    {isNewAssessmentSettingsEnabled && (
                      <div className={percentageWeightClass}>
                        {getAbsolutePercentageValueMemoize({
                          key: isSLTag ? "slWeight" : "hlWeight",
                          value: percentageWeight,
                          fieldValues: associatedChildPlannerElementNodes,
                        })}
                      </div>
                    )}
                  </>
                );
              })}
            </>
          ))}
        {isScoreV2 && isShowGradeBoundaries && canDefineGradeBoundary && (
          <div className={notAddedYetClass}>
            {gradeBoundaryId || !_.isEmpty(gradeScaleType) ? (
              <div
                className={classes.gradeBoundaryAdded}
                onClick={onClickAddedGradeBoundary}
              >
                <TickCircleFilled variant="subtle" size="xx-small" />
                <div className={addedTextClass}>{t("common:added")}</div>
              </div>
            ) : (
              t("common:not_added_yet")
            )}
          </div>
        )}
      </div>
    );
  };

  const onTemplateEdit = () => {
    setIsEditMode(true);
    onClickEditTemplate(templateId);
    if (isClassSettingsContext) {
      setClassSettingMode({
        assessmentCategoryId,
        isEditing: true,
      });
    } else {
      goToRelativeRoute({ route: `./template` });
    }
  };

  const doesAllSubjectsHaveCategorySet = getIsCategorySetsExistsForAllSubjects({
    subjects: _.filter(
      rootNodes,
      node => !_.includes(CORE_TOK_AND_OTHER_TYPES, _.get(node, "type"))
    ),
    grades,
    targetTermId: termId,
    isImportFromAnotherTerm: false,
  });

  const dropdownOptions = getDropdownOptions({
    t,
    subjectType,
    doesAllGradesHaveCategorySet,
    doesAllTermsHaveCategorySet,
    doesAllSubjectsHaveCategorySet,
    isClassSettingsContext,
    isNewTemplateDuplicationFlowEnabled,
    isGradingPeriodUnlocked,
  });

  const onClickDropdownMenu = e => {
    e.domEvent.stopPropagation();
    const action = e.key;
    switch (action) {
      case "edit":
        onTemplateEdit();
        break;
      case "duplicate":
        openDuplicateModal();
        break;
      case "duplicate_to_all":
        openDuplicateToAllSubjectsModal();
        break;
      case "duplicate_to_other_grades":
        openDuplicateToOtherGradesModal();
        break;
      case "duplicate_to_other_terms":
        openDuplicateToOtherTermsModal();
        break;
      case "delete":
        setTemplateId(templateId);
        setShowDialogueBox(true);
        break;
      default:
        onTemplateEdit();
    }
  };

  const getTooltip = () => {
    return (
      <div>
        <div className="text-label-2">
          {_.concat(
            t("academicSetup:existing_category_sets"),
            " ",
            t("academicSetup:in_this_term")
          )}
        </div>
        <ul>
          {_.map(subjectsWithCategorySet, subject => {
            const {
              name,
              pointAssessmentSets: { edges },
            } = subject;
            return _.map(edges, edge => {
              const associatedEntities = _.get(
                edge,
                "node.associatedEntities",
                []
              );
              return _.map(associatedEntities, associatedEntity => {
                if (_.get(associatedEntity, "__typename", "") === entityType) {
                  const gradeName = _.get(
                    _.find(grades, grade =>
                      _.isEqual(
                        _.get(grade, "id"),
                        _.get(associatedEntity, "id")
                      )
                    ),
                    "name"
                  );
                  return (
                    <li className="text-body-1">
                      {_.concat(name, " - ", gradeName)}
                    </li>
                  );
                } else {
                  return null;
                }
              });
            });
          })}
        </ul>
      </div>
    );
  };

  const onClickBulkImport = async params => {
    setIsLoading(true);
    await copyPointAssessment({
      id: templateId,
      label: templateName,
      entitesForCopySet: getAssociatedEntitiesForBulkImport(params),
      curriculumProgramId,
      pointSetVariables,
      type: "ASSESSMENT_CATEGORY",
      scoreBasedAssessmentVariables,
    });
    setIsLoading(false);
    closeDuplicateModal();
  };

  const containerStyle = classNames({
    [classes.classSettingContainer]: isClassSettingsContext,
    [classes.container]: !isClassSettingsContext,
  });

  const templateHeaderSyle = classNames({
    [classes.templateHeaderText]: true,
    [classes.templateHeaderTextForClassContext]: isClassSettingsContext,
  });

  const headerLeftCntainerStyle = classNames({
    [classes.headerLeftContainer]: isClassSettingsContext,
  });

  const headerContainerSyle = classNames({
    [classes.headerContainer]: true,
    [classes.headerContainerForClassContext]: isClassSettingsContext,
  });

  const categoryTemplateDataCellSyle = classNames({
    [classes.categoryTemplateDataCell]: !isClassSettingsContext,
    [classes.categoryTemplateDataCellForClassSettings]: isClassSettingsContext,
  });

  const gradeBoundaryModalParams = {
    t,
    termId,
    subjectId,
    subjectType,
    ...modalParams,
    isViewMode: true,
    curriculumProgramId,
    defaultGradeScaleSet,
    subjectLevelGenericTags,
    closeModal: () => setModalParams({}),
    currentCategoryGradeBoundaryValues,
    overallCategoryGradeBoundaryValues,
    updateCurrentCategoryGradeBoundaryValues,
    updateOverallCategoryGradeBoundaryValues,
    showUpdatedDesign,
  };

  const defineGradeBoundariesLabelClass = classNames(
    classes.defineGradeBoundariesLabel,
    "text-body-1"
  );

  return (
    <React.Fragment>
      <div className={containerStyle}>
        <div className={headerContainerSyle}>
          <div className={headerLeftCntainerStyle}>
            <div className={templateHeaderSyle}>{templateName}</div>
            {!isClassSettingsContext ? (
              <div className={classes.gradeContainer}>
                <span className={classes.gradeHeader}>
                  {`${t("common:applicable_with_label", {
                    label: t("common:to"),
                  })}`}
                </span>
                {_.join(coursesName, ", ")}
              </div>
            ) : null}
            {user && updatedTimeStamp?.isValid() ? (
              <div className={classes.lastUpdatedText}>
                {`(${t("progressSummary:last_updated_by_name_on_date_at_time", {
                  name,
                  date: updatedDate,
                  time: updatedTime,
                })})`}
              </div>
            ) : null}
          </div>
          {isTeacherAllowedToAddEditCategories ? (
            isScoreV2 ? (
              <Dropdown
                getPopupContainer={el => {
                  return el;
                }}
                overlay={
                  <DropdownMenu
                    onClick={onClickDropdownMenu}
                    options={dropdownOptions}
                  />
                }
                placement={"bottomRight"}
              >
                <IconButton
                  size={isClassSettingsContext ? "small" : "medium"}
                  onClick={e => {
                    e.stopPropagation();
                  }}
                  icon={
                    <DotsHorizontalOutlined variant="subtle" size="xx-small" />
                  }
                  _legacy_variant="outlined-subtle"
                  variant="neutral"
                  type="outlined"
                />
              </Dropdown>
            ) : (
              <div>
                <Button
                  _legacy_variant="outlined"
                  variant="neutral"
                  type="outlined"
                  onClick={() => onTemplateEdit()}
                >
                  {t("common:edit")}
                </Button>
              </div>
            )
          ) : null}
        </div>
        {showCategoryGradeBoundaryToggle ? (
          <div className={classes.defineGradeBoundaries}>
            {isShowGradeBoundaries ? (
              <TickCircleFilled variant="success" />
            ) : (
              <CloseCircleOutlined disabled={true} />
            )}
            <div className={defineGradeBoundariesLabelClass}>
              {getCategoryGradeBoundaryToggleLabel({
                t,
                isCurriculumUBD,
                finalGradeCalculationMethod,
              })}
            </div>
          </div>
        ) : null}
        <div className={classes.categoryTemplateHeader}>
          <div className={categoryHeaderTextClass}>
            {t("academicSetup:assessment_categories")}
          </div>
          {isWeightageEnabledForCategory &&
            (!isCurriculumDP ||
            (isCurriculumDP && _.isEmpty(subjectLevelGenericTags)) ? (
              <>
                <div className={categoryWeightTextClass}>
                  {isNewAssessmentSettingsEnabled
                    ? t("common:weight")
                    : isAbsoluteWeightageType
                    ? t("academicSetup:absolute_weight")
                    : t("common:percentage_weight")}
                </div>
                {isNewAssessmentSettingsEnabled && (
                  <div className={categoryWeightTextClass}>%</div>
                )}
              </>
            ) : (
              <>
                {_.map(subjectLevelGenericTags, tag => {
                  const tagLabel = _.get(tag, "label", "");
                  const categoryWeightText = isNewAssessmentSettingsEnabled
                    ? `${t("common:weight")} (${tagLabel})`
                    : isAbsoluteWeightageType
                    ? t(`academicSetup:absolute_weight_${_.toLower(tagLabel)}`)
                    : t(
                        `academicSetup:percentage_weight_${_.toLower(tagLabel)}`
                      );

                  return (
                    <>
                      <div className={categoryWeightTextClass}>
                        {categoryWeightText}
                      </div>
                      {isNewAssessmentSettingsEnabled && (
                        <div className={categoryWeightTextClass}>
                          {`% (${tagLabel})`}
                        </div>
                      )}
                    </>
                  );
                })}
              </>
            ))}
          {isScoreV2 && isShowGradeBoundaries && canDefineGradeBoundary && (
            <div className={classes.categoryContainer}>
              <div className={gradeBoundaryTextClass}>
                {t("academicSetup:grade_boundary")}
              </div>
            </div>
          )}
        </div>
        {_.map(
          associatedChildPlannerElementNodes,
          associatedChildPlannerElementNode =>
            renderCategory({
              associatedChildPlannerElementNode,
              setModalParams,
            })
        )}
      </div>
      {showModal && (
        <DuplicateTemplateModal
          t={t}
          modalState={modalState}
          subjectName={subjectName}
          templateName={templateName}
          closeModal={closeModal}
          getTooltip={getTooltip}
          grades={grades}
          usedCourses={usedCourses}
          gradesWithNoCategorySet={gradesWithNoCategorySet}
          selectedGrades={selectedGrades}
          setSelectedGrades={setSelectedGrades}
          onClickDuplicate={onClickDuplicate}
          rootNodes={rootNodes}
          terms={terms}
          selectedTerms={selectedTerms}
          setSelectedTerms={setSelectedTerms}
          usedTerms={usedTerms}
          termsWithNoCategorySet={termsWithNoCategorySet}
        />
      )}
      {!_.isEmpty(modalParams) ? (
        isCurriculumDP || isCurriculumMYP ? (
          <CategoryGradeBoundary {...gradeBoundaryModalParams} />
        ) : (
          <CategoryGradeScale {...gradeBoundaryModalParams} />
        )
      ) : null}
      {showDuplicateModal && (
        <BulkDuplicateTemplateModal
          templateName={templateName}
          closeModal={closeDuplicateModal}
          targetTermId={termId}
          grades={grades}
          subjectGroups={subjectGroups}
          rootNodes={rootNodes}
          isCurriculumDP={isCurriculumDP}
          onClickImport={onClickBulkImport}
          sourceSubjectGenericTags={subjectLevelGenericTags}
        />
      )}
      {isLoading && <FullScreenLoader />}
    </React.Fragment>
  );
};

const mapStateToProps = (state, ownProps) => {
  const {
    curriculumProgramId,
    curriculumType,
    subjectType,
    canOverrideFinalGrade,
    templateNode,
  } = ownProps;

  const isAssessmentSetupV2Enabled = checkIsAssessmentSetupV2Enabled();

  const associatedEntities = _.get(templateNode, "associatedEntities");
  const gradeId = _.get(
    _.find(associatedEntities, { __typename: "Grade" }),
    "id"
  );

  const canDefineGradeBoundary = getCanDefineGradeBoundary({
    curriculumProgramId,
    isScoreV2: true,
    curriculumType,
    subjectType,
    gradeId,
  });

  const finalGradeCalculationMethod = getSettingValue({
    name: FINAL_GRADE_CALCULATION_SETTING,
    currentCurriculumProgramId: curriculumProgramId,
    gradeId,
  });

  const showCategoryGradeBoundaryToggle = getShowCategoryGradeBoundaryToggle({
    curriculumType,
    curriculumProgramId,
    subjectType,
    finalGradeCalculationMethod,
    canOverrideFinalGrade,
  });

  return {
    isNewTemplateDuplicationFlowEnabled: ACLStore.can(
      "FeatureFlag:EnableNewTemplateDuplicationFlow"
    ),
    isAssessmentSetupV2Enabled,
    canDefineGradeBoundary,
    finalGradeCalculationMethod,
    showCategoryGradeBoundaryToggle,
  };
};

const mapActionCreators = {
  copyPointAssessment,
  setToastMsg,
  showToastAfterDuplicatingCategorySetsToGrade,
};

export default connect(mapStateToProps, mapActionCreators)(CategoryTemplate);
